const TextComponent = (props) => {
    return <div className="text-center textColor" >
        <p className="blockquote">{props.label}</p>
    </div>
}

export default TextComponent;